import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-4">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center">
              <Shield className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-slate-900">Privacy Policy</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200">
          <p className="text-slate-500 text-sm mb-8">Last updated: January 2025</p>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Information We Collect</h2>
            <p className="text-slate-600 mb-6">
              We collect information you provide directly to us, including your name, email address, 
              and Google Business Profile data when you connect your account. We also collect 
              information about your usage of our services.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">2. How We Use Your Information</h2>
            <p className="text-slate-600 mb-6">
              We use the information we collect to provide, maintain, and improve our services, 
              including generating AI-powered responses to your Google reviews. We do not sell 
              your personal information to third parties.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Data Security</h2>
            <p className="text-slate-600 mb-6">
              We implement appropriate technical and organizational measures to protect your 
              personal information against unauthorized access, alteration, disclosure, or 
              destruction. Your Google API tokens are encrypted and stored securely.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Third-Party Services</h2>
            <p className="text-slate-600 mb-6">
              Our service integrates with Google Business Profile API and OpenAI. Your use of 
              these services is subject to their respective privacy policies. We only access 
              the minimum data necessary to provide our services.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Data Retention</h2>
            <p className="text-slate-600 mb-6">
              We retain your data for as long as your account is active or as needed to provide 
              you services. You can request deletion of your data at any time by contacting us.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Your Rights</h2>
            <p className="text-slate-600 mb-6">
              You have the right to access, correct, or delete your personal information. 
              You can disconnect your Google account and revoke our access at any time through 
              your Google Account settings.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Contact Us</h2>
            <p className="text-slate-600">
              If you have any questions about this Privacy Policy, please contact us at{' '}
              <Link to="/contact" className="text-blue-600 hover:underline">our contact page</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
